module.exports = __webpack_public_path__ + "static/media/poster-video-sm.e07a72a3.jpg";